import { render, staticRenderFns } from "./checkout-payment-headline.vue?vue&type=template&id=20a6d996&scoped=true"
import script from "./checkout-payment-headline.vue?vue&type=script&lang=js"
export * from "./checkout-payment-headline.vue?vue&type=script&lang=js"
import style0 from "./checkout-payment-headline.vue?vue&type=style&index=0&id=20a6d996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a6d996",
  null
  
)

export default component.exports